import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'timeRemaining' })
export class TimeRemainingPipe implements PipeTransform {
  public transform(dateStr: string): any {
    const date = new Date(dateStr);
    let result: string;
    if (!dateStr || date.getFullYear() == 1970) { return 'never'; }

    // current time
    const now = new Date().getTime();

    // time since message was sent in seconds
    const delta = (date.getTime() - now) / 1000;

    if (delta < 0) {
      result = 'expired';
    } else if (delta < 60) {
      result = Math.floor(delta) + ' seconds remaining';
    } else if (delta < 3600) {
      result = Math.floor(delta / 60) + ' minute ' + Math.floor(delta - 60) + ' seconds remaining';
    } else if (delta < 3600 * 2) {
      result = Math.floor(delta / 60) + ' minutes remaining';
    } else if (delta < 86400) {
      result = Math.floor(delta / 3600) + ' hours ' + Math.floor((delta - 3600) / 60) + ' minutes remaining';
    } else if (delta < 86400 * 2) {
      result = Math.floor(delta / 86400) + ' day ' + Math.floor((delta - 86400) / 3600) + ' hours remaining';
    } else {
      result = Math.floor(delta / 86400) + ' days remaining';
    }

    return result;
  }
}
